module.exports = __webpack_public_path__ + "img/Horizontal.b1900be7.svg";